import useProfileCommonStore from './use-profile-common-store';

import {
  useProfileMaturityAllocation,
  useProfileAssetAllocation,
  useProfileFeesExpenses,
  useProfileInvestmentFacts,
  useProfileInvestmentHoldings,
  useProfileInvestmentStrategy,
  useProfileMarketCapitalization,
  useProfileMorningstarFactsRatings,
  useQuote,
  PROFILE_API_TYPES,
  useProfileDisclosures
} from '../../hooks/api';

const useAfterTaxAnnuityStore = () => {
  const { apiConfigBase, commonState } = useProfileCommonStore();

  return {
    ...commonState,
    maturityAllocation: useProfileMaturityAllocation(apiConfigBase),
    assetAllocation: useProfileAssetAllocation(apiConfigBase),
    disclosureList: useProfileDisclosures({ ...apiConfigBase, forPrint: true }),
    feesExpenses: useProfileFeesExpenses({ ...apiConfigBase, apiType: PROFILE_API_TYPES.prop }), // Remove this after the related consolidation ticket is completed TIAA-8799
    investmentFacts: useProfileInvestmentFacts(apiConfigBase),
    investmentHoldings: useProfileInvestmentHoldings(apiConfigBase),
    investmentStrategy: useProfileInvestmentStrategy(apiConfigBase),
    marketCapitalization: useProfileMarketCapitalization(apiConfigBase),
    morningstarFactsRatings: useProfileMorningstarFactsRatings(apiConfigBase),
    quote: useQuote(apiConfigBase)
  };
};

export default useAfterTaxAnnuityStore;
